import Button from "@material-ui/core/Button"
import React, { ReactNode } from "react"
import { Container } from "@material-ui/core"
import clsx from "clsx"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import * as styles from "./liteBanner.module.scss"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import { variantConfig } from "./variants"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

type LiteBannerProps = {
  headTitle?: ReactNode
  headDescr?: string
  orderNum: string
  dataVariant: "subscription" | "download"
  styleVariant: "subscription" | "download"
}

export const LiteBanner = ({
  headTitle = "Подписка «Халва.Десятка»",
  headDescr = "Первый месяц 0 ₽, далее 399 ₽ в месяц",
  dataVariant,
  styleVariant,
  orderNum,
}: LiteBannerProps) => {
  const isDesktop = useMediaQuery("(min-width:1279.95px)")

  const { Icon, altText, buttonText } = variantConfig[dataVariant]

  const handleClickButton = () => {
    if (dataVariant === "subscription") {
      DLClickEventExtended({
        name: buttonText,
        eventAction: "Подписка Халва.Десятка",
        placement: "promo",
      })

      scrollToPersonalForm()
    } else if (dataVariant === "download") {
      window.open(
        "https://pwa.scb.ru/?utm_medium=Referral&utm_source=halvacard.ru&utm_campaign=app-download-block",
        "_blank"
      )
    }
  }

  const shouldShowButton = buttonText && !(dataVariant === "download" && isDesktop)

  return (
    <div id={dataVariant} data-exclude={orderNum}>
      <Container className={clsx(styles.container, styleVariant && styles[styleVariant])}>
        <div className={styles.card}>
          <div>
            {headTitle && <h3 className={styles.headTitle}>{headTitle}</h3>}
            {headDescr && <p className={styles.headDescr}>{headDescr}</p>}
          </div>
          {shouldShowButton && (
            <Button disableRipple onClick={handleClickButton} className={styles.btn}>
              {buttonText}
            </Button>
          )}
          <Icon alt={altText} className={styles.img} />
        </div>
      </Container>
    </div>
  )
}
